import { colorsCromatic } from "../../themes/colors";
import { colorSchemes } from "@nivo/colors";
import getColorsForScheme from "../../componentes/legends/utils/getColorsForScheme";
type ColorShades = {
  [key: string]: string;
};

type ColorsMap = {
  [key: string]: ColorShades;
};

export function getColorsArray(
  quantity: number,
  colors: any,
  colorMode: boolean,
) {
  let colorsDefault = colorsCromatic(colorMode) as ColorsMap;
  const scheme = colors?.scheme;

  if (!scheme) {
    return returnColors(colorSchemes.nivo as string[], quantity);
  }

  if (scheme in colorsDefault) {
    return returnColors(Object.values(colorsDefault[colors.scheme]), quantity);
  }

  return getColorsForScheme(scheme, quantity);
}

const returnColors = (colorShades: string[], num: number) => {
  return Array.from(
    { length: num },
    (_, i) => colorShades[i % colorShades.length],
  );
};
